import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { DepartmentPickerComponent } from '@modules/department/components/department-picker/department-picker.component';
import { TuiError } from '@taiga-ui/core';
import { TelemonitoringRequestForm } from '../telemonitoring-request/telemonitoring-request-form';

@Component({
  selector: 'pxc-telemonitoring-request-location',
  imports: [CommonModule, DepartmentPickerComponent, TuiError, FormsModule, ReactiveFormsModule, TranslocoDirective],
  templateUrl: './telemonitoring-request-location.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelemonitoringRequestLocationComponent {
  @Input() form: FormGroup<TelemonitoringRequestForm>;

  get clientCode(): string {
    return this.form.get('clientCode').value;
  }

  get departmentIds(): number[] {
    return this.form.get('departmentIds').value;
  }

  setDepartmentIds(departmentIds: number[]): void {
    this.form.get('departmentIds').setValue(departmentIds);
    this.form.get('departmentIds').markAsTouched();
  }
}
